// extracted by mini-css-extract-plugin
export default {"subtitle":"Subtitle-module__subtitle__MbaqY"};